// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2DB2_","content":"ManualTimeModal_content__3VlrO"};